export const LOAD_CONFIG_SUCCESS = 'LOAD_CONFIG_SUCCESS';
export const SET_COOKIE_SETTINGS = 'SET_COOKIE_SETTINGS';
